
export function TimelineSection() {
  const milestones = [
    {
      year: '2024',
      quarter: 'Q1',
      title: 'Company Founded',
      description: 'Idris and Tommy establish Driscop in Manchester, identifying the critical gap in SME cybersecurity protection.'
    },
    {
      year: '2024',
      quarter: 'Q2',
      title: 'AI Development Begins',
      description: 'Started developing our UK-specific threat detection AI, training on regional phishing and smishing datasets.'
    },
    {
      year: '2024',
      quarter: 'Q3',
      title: 'Beta Testing Launch',
      description: 'Launched beta testing with 50 Manchester-based SMEs, achieving 99.7% threat detection accuracy.'
    },
    {
      year: '2024',
      quarter: 'Q4',
      title: 'Platform Launch',
      description: 'Official launch of Driscop platform, protecting 5,000+ UK businesses within first month.'
    },
    {
      year: '2025',
      quarter: 'Q1',
      title: 'UK Expansion',
      description: 'Expanding across major UK cities with enhanced integrations and enterprise features.'
    },
    {
      year: '2025',
      quarter: 'Q3',
      title: 'European Growth',
      description: 'Planned expansion into European markets, adapting our AI for regional threat patterns.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Our Journey
            </h2>
            <p className="text-xl text-gray-400">
              From Manchester startup to UK cybersecurity leader
            </p>
          </div>

          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-blue-200"></div>

            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div key={index} className="relative flex items-start">
                  {/* Timeline dot */}
                  <div className={`absolute left-6 w-4 h-4 rounded-full border-4 ${
                    index <= 3 ? 'bg-blue-400 border-blue-400' : 'bg-gray-800/50 border-blue-400'
                  }`}></div>
                  
                  {/* Content */}
                  <div className="ml-16">
                    <div className="flex items-center mb-2">
                      <span className="text-sm font-medium text-blue-400 bg-blue-500/20 px-3 py-1 rounded-full mr-3">
                        {milestone.year} {milestone.quarter}
                      </span>
                      {index <= 3 && (
                        <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full">
                          Completed
                        </span>
                      )}
                    </div>
                    <h3 className="text-xl font-semibold text-white mb-2">
                      {milestone.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {milestone.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
